export default function updateTree(tree, path, cb) {
  const root = { ...tree }
  const keys = path.split('.')
  const field = keys.pop()
  const parent = keys.reduce((tree, key) => tree[key] = { ...tree[key] }, root)
  parent[field] = cb(parent[field])
  return root
}
